







































import { defineComponent, ref } from 'vue-demi';
import { useI18n } from 'common-module/src/util/useI18n';

export default defineComponent({
  name: 'EditNameInput',
  components: {

  },
  props: {
    name: {
      type: String,
      default: ''
    }
  },
  setup(props, { emit }) {

    const { t } = useI18n();
    const inputRef = ref();
    const inputValue = ref('');
    const isEdit = ref(false);

    const onEdit = () => {
      isEdit.value = true;
      inputValue.value = props.name;
      setTimeout(() => {
        inputRef.value.focus();
      }, 100);
    };

    const onUpdate = () => {
      isEdit.value = false;
      const name = inputValue.value?.trim();
      if (!name || name === props.name) {
        return;
      }
      emit('update', name);
    };

    return {
      inputRef,
      inputValue,
      isEdit,
      onEdit,
      onUpdate,
      t
    };
  }
});
